import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faEyeSlash,
  faSpinner
} from '@fortawesome/free-solid-svg-icons';
import ModalTailwind from '../../components/ModalTailwind';
import axios from 'axios';

const RecuperarContrasena = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState(''); // ✅ nuevo estado para error

  const handleChange = (e) => {
    setErrorMessage(''); // Limpiar error al escribir
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async () => {
    setErrorMessage(''); // ✅ limpiar errores al iniciar

    if (!formData.newPassword || !formData.confirmPassword) {
      setErrorMessage('Todos los campos son obligatorios');
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setErrorMessage('Las contraseñas no coinciden');
      return;
    }

    try {
      setLoading(true);

      await axios.post(
        'https://www.fancyplus.digital/api/users/reset-password',
        {
          token,
          newPassword: formData.newPassword
        },
        {
          withCredentials: true
        }
      );

      setModalVisible(true); // ✅ solo éxito muestra modal
    } catch (err) {
      const msg = err?.response?.data?.message || 'Ocurrió un error al actualizar la contraseña';
      setErrorMessage(msg); // ✅ mostrar error en pantalla
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    navigate('/login');
  };

  return (
    <div className="max-w-md mx-auto p-6 mt-10 bg-white shadow-md rounded">
      <h2 className="text-xl font-semibold text-gray-800 mb-6 text-center">🔐 Recuperación de contraseña</h2>

      {/* Nueva contraseña */}
      <div className="mb-4 relative">
        <label className="block text-sm font-medium text-gray-700">Nueva contraseña</label>
        <input
          type={showPassword ? 'text' : 'password'}
          name="newPassword"
          value={formData.newPassword}
          onChange={handleChange}
          className="block w-full border px-3 py-2 rounded-md mt-1"
        />
        <FontAwesomeIcon
          icon={showPassword ? faEyeSlash : faEye}
          className="absolute right-3 top-[38px] text-gray-600 cursor-pointer"
          onClick={() => setShowPassword(!showPassword)}
        />
      </div>

      {/* Confirmar contraseña */}
      <div className="mb-6 relative">
        <label className="block text-sm font-medium text-gray-700">Confirmar nueva contraseña</label>
        <input
          type={showConfirm ? 'text' : 'password'}
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleChange}
          className="block w-full border px-3 py-2 rounded-md mt-1"
        />
        <FontAwesomeIcon
          icon={showConfirm ? faEyeSlash : faEye}
          className="absolute right-3 top-[38px] text-gray-600 cursor-pointer"
          onClick={() => setShowConfirm(!showConfirm)}
        />
      </div>

      {/* 🔴 Error textual */}
      {errorMessage && (
        <p className="text-red-600 mt-3 text-sm text-center">{errorMessage}</p>
      )}

      {/* Botón */}
      <div className="relative mb-2">
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="w-full py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50"
        >
          Cambiar contraseña
        </button>
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 rounded">
            <FontAwesomeIcon icon={faSpinner} spin className="text-green-600 text-xl" />
          </div>
        )}
      </div>

      

      {/* ✅ Modal de éxito intacto */}
      <ModalTailwind show={modalVisible} onClose={handleCloseModal}>
        <div className="p-4 text-center">
          <h3 className="text-lg font-semibold mb-2 text-green-600">Contraseña actualizada</h3>
          <p className="text-sm text-gray-700 mb-4">
            Tu contraseña ha sido actualizada correctamente.
          </p>
          <button
            onClick={handleCloseModal}
            className="px-4 py-2 rounded text-white bg-blue-600 hover:bg-blue-700"
          >
            Iniciar sesión ahora
          </button>
        </div>
      </ModalTailwind>
    </div>
  );
};

export default RecuperarContrasena;
